import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { getBreadcrumbs } from '../data/navigation';

/**
 * Breadcrumbs — derives the trail from the module navigation config.
 * Renders <Dashboard> for the root, then <Group> / <Module> as applicable.
 */
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const crumbs = getBreadcrumbs(pathname);

  return (
    <nav className="app-breadcrumbs" aria-label="Breadcrumb">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <React.Fragment key={`${crumb.label}-${index}`}>
            {index > 0 && <ChevronRight size={14} className="app-breadcrumbs__sep" aria-hidden="true" />}
            {isLast ? (
              <span className="app-breadcrumbs__item app-breadcrumbs__item--current">{crumb.label}</span>
            ) : (
              <Link className="app-breadcrumbs__item" to={crumb.path || '/'}>
                {crumb.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
